import { API_ROUTES } from '@/constants/apiRoutes';
import { AxiosInstance } from 'axios';

export interface DeleteMainPageStorePayload {
  recommendationId: string;
}

const deleteMainPageStore = (client: AxiosInstance) => async (payload: DeleteMainPageStorePayload) => {
  return (await client.post<{ message: string }>(API_ROUTES.DELETE_MAIN_PAGE_STORE, payload)).data;
};

export const mainPageStoreMutations = {
  deleteMainPageStore,
};
